/**
 *
 * @module accessTokenProvider
 * @see https://github.bamtech.co/sdk-doc/spec-sdk/blob/master/specs/feature_overviews/token.md
 *
 */

import Check from 'check-types';
import EventEmitter from 'events';
import Logging from './../logging/entry';
import AccessToken from './accessToken';

/**
 *
 * @class AccessTokenProvider
 * @extends {EventEmitter}
 * @see https://nodejs.org/api/events.html
 * @desc Provides the Access token and associated state.
 *
 */
export default class AccessTokenProvider extends EventEmitter {

    /**
     *
     * @param {AccessStorage} [accessStorage=null]
     * @param {SDK.Logging.Logger} [logger=Logging]
     *
     */
    constructor(accessStorage = null, logger = Logging) {

        super();

        /**
         *
         * @access private
         * @type {AccessStorage}
         * @note returns storage instance to be used when AccessTokenProvder is
         * not extended
         *
         */
        this.accessStorage = accessStorage;

        /**
         *
         * @access private
         * @type {AccessToken|null}
         *
         */
        this.accessToken = this.getAccessToken();

        /**
         *
         * @access private
         * @type {SDK.Logging.Logger}
         *
         */
        this.logger = logger;

        this.logger.log(AccessTokenProvider.name, 'Created.');

    }

    /**
     *
     * @access private
     * @emits {AccessChange} The event raised each time a access token is updated.
     * @returns {AccessToken|null}
     *
     */
    getAccessToken() {

        const { logger } = this;

        const storage = this.storage ? this.storage : this.accessStorage;
        const access = storage && storage.getAccess();

        if (Check.not.assigned(access)) {
            return null;
        }

        const accessToken = new AccessToken(access.context.token);

        if (this.hasTokenChanged(accessToken)) {

            logger.info(AccessTokenProvider.name, 'Dispatch AccessChange event.');

            this.emit('AccessChange', accessToken);

        }

        this.accessToken = accessToken;

        return this.accessToken;

    }

    /* #region private: */

    /**
     *
     * @access private
     * @param {AccessToken} providerToken
     * @desc determines if the access token value has been updated
     * @returns {Boolean}
     *
     */
    hasTokenChanged(providerToken) {

        const accessToken = this.accessToken;

        if (Check.assigned(accessToken) && Check.assigned(providerToken)) {
            if (Check.not.equal(accessToken.token, providerToken.token)) {
                return true;
            }
        }

        return false;

    }

}



// WEBPACK FOOTER //
// ./src/token/accessTokenProvider.js